// Generated via jq:
// jq 'reduce .icons[] as $i ({}; .[$i.properties.name] = $i.properties.code)' < node_modules/@aha-app/aha-icon/aha-icon/selection.json

// If you don't have jq, you can also generate in Rails console:
// icon_selection = JSON.parse(File.read("node_modules/@aha-app/aha-icon/aha-icon/selection.json"))
// icon_selection["icons"].to_h { |icon| [icon.dig("properties", "name"), icon.dig("properties", "code")] }.to_json

const AhaIconGlyphs = {
  'record-icon': 59802,
  confluence: 59801,
  'bulk-edit': 59799,
  gear: 59797,
  'open-view': 59798,
  'lightbulb-star': 59792,
  'pencil-star': 59793,
  shorten: 59794,
  summarize: 59795,
  target: 59796,
  'shared-snippet': 59791,
  records: 59790,
  reposition: 59788,
  'original-ratio': 59789,
  'convert-record': 59733,
  wireframe: 59787,
  'idea-promoted': 59786,
  academy: 59782,
  develop: 59775,
  knowledge: 59776,
  roadmaps: 59777,
  whiteboards: 59781,
  ideas: 59785,
  'book-dot': 59774,
  voting: 59773,
  'recurring-task': 59772,
  'custom-roadmap-rows-thick': 59771,
  'pivot-report-rows-compact': 59778,
  'pivot-report-rows-normal': 59779,
  'custom-roadmap-rows-thin': 59780,
  'custom-roadmap-rows-normal': 59783,
  'custom-roadmap-rows-compact': 59784,
  bitbucket: 59770,
  cylinder: 59769,
  circleci: 59767,
  figma: 59768,
  'four-bars': 59765,
  'three-bars': 59766,
  'product-value-score-equation': 59763,
  'product-value-score': 59764,
  'add-tab': 59762,
  zendesk: 59692,
  'azure-import': 59761,
  gitlab: 59760,
  sentry: 59759,
  'rally-import': 59758,
  trello: 59757,
  'custom-field': 59755,
  'new-custom-field': 59756,
  github: 59754,
  doughnut: 59753,
  'ideas-submission-lightbulb': 59752,
  'epic-solid': 59749,
  'roadmap-solid': 59750,
  'strategic-model-solid': 59751,
  'dynamic-form': 59748,
  'check-list': 59746,
  upload: 59747,
  'record-details': 59744,
  'record-drawer': 59745,
  attachment: 59743,
  poll: 59742,
  'empathy-nav': 59741,
  plus: 59740,
  'arrow-left': 59736,
  close: 59737,
  search: 59738,
  trash: 59739,
  empathy: 59734,
  session: 59735,
  'strategic-model': 59732,
  smile: 59729,
  'question-circle': 59730,
  airplane: 59731,
  'jump-to': 59728,
  info: 59726,
  clock: 59727,
  'add-reaction': 59724,
  'reply-arrow': 59725,
  feedback: 59723,
  'question-mark': 59718,
  'close-icon': 59719,
  demo: 59720,
  email: 59721,
  chat: 59722,
  share: 59717,
  'approved-with-changes': 59712,
  approved: 59713,
  complete: 59714,
  decline: 59715,
  pending: 59716,
  'add-comment': 59711,
  azure: 59709,
  rally: 59710,
  presentation: 59708,
  'invite-colleagues': 59707,
  'tour-demo-product': 59706,
  'hide-comment': 59705,
  sum: 59704,
  fx: 59703,
  'creative-brief': 59702,
  'enterprise-transformation': 59700,
  templates: 59701,
  dependencies: 59699,
  announcement: 59698,
  sort: 59697,
  excel: 59696,
  dropbox: 59695,
  box: 59693,
  onedrive: 59694,
  'scatter-graph': 59679,
  'aha-exclamation': 59648,
  'align-bottom': 59649,
  'align-middle': 59650,
  'align-top': 59651,
  'arrow-left-once': 59652,
  'arrow-right-once': 59653,
  asana: 59654,
  'bring-forward': 59655,
  'bring-to-front': 59656,
  'choice-list-o': 59657,
  circles: 59658,
  connect: 59659,
  'customer-card': 59660,
  date: 59661,
  diagram: 59662,
  details: 59663,
  'google-drive': 59664,
  hierarchy: 59665,
  import: 59666,
  jira: 59667,
  epic: 59668,
  misc: 59669,
  'number-square-o': 59670,
  person: 59671,
  pivot: 59672,
  rectangles: 59673,
  redo: 59674,
  report: 59675,
  roadmap: 59676,
  rollup: 59677,
  salesforce: 59678,
  scrum: 59680,
  'send-backward': 59681,
  'send-to-back': 59682,
  shape: 59683,
  summary: 59684,
  tag: 59685,
  'text-square-o': 59686,
  'type-tool': 59687,
  undo: 59688,
  views: 59689,
  waterfall: 59690,
  workflow: 59691,
  'empathy-feedback': 59800,
};

export type AhaIcons = keyof typeof AhaIconGlyphs;

export default AhaIconGlyphs;
